import script from "./CrudPedidos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudPedidos.vue?vue&type=script&setup=true&lang=js"

import "./CrudPedidos.vue?vue&type=style&index=0&id=62cadd1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62cadd1e"]])

export default __exports__